// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__dtdLb","spin":"loader_spin__GqPvN"};